<template>
  <div class="heador" :class="{ fixed: fixed }">
    <div class="left">
      <span class="iconfont icon-fanhui"  @click="goBack()"></span>
    </div>
    <p class="title">{{ title }}</p>
    <div class="right"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    title: "",
    back: false,
    fixed: false,
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  z-index: 99;
}
.heador {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  height: 1rem;
  .title {
    font-size: 0.32rem;
    font-weight: 550;
  }
  .left {
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    span {
      font-size: 0.4rem;
    }
  }
  .right {
    min-width: 1rem;
    min-height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0.3rem;
    top: 0;
  }
}
</style>